import { render, staticRenderFns } from "./about_page.vue?vue&type=template&id=4a4b65be&scoped=true&"
import script from "./about_page.vue?vue&type=script&lang=js&"
export * from "./about_page.vue?vue&type=script&lang=js&"
import style0 from "./about_page.vue?vue&type=style&index=0&id=4a4b65be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4b65be",
  null
  
)

export default component.exports